import { render } from "./TypeImage.vue?vue&type=template&id=64876999"
import script from "./TypeImage.vue?vue&type=script&lang=js"
export * from "./TypeImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__